import React from 'react'
import Nav from '../Nav/Nav'
import Footer from '../Footer/Footer'
import CHero from '../Common/CHero'
import JoinBody from './JoinBody'

const Join = () => {
  return (
    <>
    <Nav />
    <JoinBody />
    <Footer />
    </>
  )
}

export default Join